import { isEmpty } from 'lodash-es';
import * as React from 'react';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { existsSync, mkdirSync, readdirSync, readFileSync, rmSync, writeFileSync } from 'fs';

import { generateRoutes } from '../components/routes-generator';
import { IndexPageProps, RouteProps } from '../types/route.types';
import convert from '../utils/convert-utils';
import styles from './home.component.module.scss';
import path from 'path';

interface HomePageState {
    keywordFilter: (v) => boolean;
}

// export async function getStaticPaths() {
//     const routes = generateRoutes(true);
//     return {
//         paths: [
//             ...routes.map(r => {
//                 console.log(r);
//                 r.test = "ASDSADASD";
//                 return { params: r };
//             }) // See the "paths" section below
//         ],
//         fallback: false // See the "fallback" section below
//     };
// }

// This also gets called at build time
export async function getStaticProps3({ params }) {
    // params contains the post `id`.
    // If the route is like /posts/1, then params.id is 1
    const post = { test: 1 }
    const routes = generateRoutes(true);
    const route = routes.find(r => r.id === 'home');
    // Pass post data to the page via props
    console.log(params, "11111", route);
    return { props: { ...params, ...route } };
}

export async function getStaticProps({ params }) {
    const indexDataJson = path.resolve(process.cwd(), 'ssr/build/route-content/index.json');
    const indexData = readFileSync(indexDataJson, 'utf8')
    return {
        props: {
            ...JSON.parse(indexData)
        }
    }
}

export default class HomeComponent extends React.Component<IndexPageProps, HomePageState> {
    measureToData: {
        [unit: string]: {
            measureReadableName: string
            measureUnits: {
                urlText: string;
                url: string;
            }[]
        }
    } = {};
    nameCache = {};
    sortedMeasureToDataKeys = [];
    filterRef = React.createRef<HTMLSelectElement>();
    keywordFilterRef = React.createRef<HTMLInputElement>();
    measureFilter: string; // measure

    searchSubject = new Subject();


    constructor(props: IndexPageProps) {
        super(props);
        this.state = { keywordFilter: (a) => true };
        for (const converter of props.converters) {
            const measureReadableName = converter.name;
            this.measureToData[converter.id] = {
                measureReadableName: measureReadableName,
                measureUnits: converter.links,
            };
        }

        this.updateSortedMeasureToDataKeys();
        this.searchSubject.pipe(debounceTime(100)).subscribe({
            next: (filter) => {
                this.setState(filter);
            }
        })
    }

    getUnitDescription(unit) {
        if (!this.nameCache[unit]) {
            this.nameCache[unit] = convert().describe(unit).plural;
        }
        return this.nameCache[unit]
    }

    updateSortedMeasureToDataKeys() {
        this.sortedMeasureToDataKeys = Object.keys(this.measureToData).sort((a, b) => this.measureToData[a].measureUnits.length - this.measureToData[b].measureUnits.length)
    }

    updateFilter() {
        this.measureFilter = this.filterRef.current.value === 'all' ? null : this.filterRef.current.value;
        setTimeout(() => this.forceUpdate(), 50);
    }

    keywordFilterChanged() {
        const filterTokens = (this.keywordFilterRef.current.value || '').split(/\W/)
            .map(token => token.trim())
            .filter(token => !isEmpty(token))
            .filter(token => token !== 'to' && token !== 'and' && token.length > 1);
        if (filterTokens.length === 0) {
            this.searchSubject.next({
                keywordFilter: (a) => true,
            });
            return;
        }
        this.searchSubject.next({
            keywordFilter: (a) => {
                return filterTokens.every(t => a.match(new RegExp(t, "i")));
            },
        });
    }

    render() {
        return <div className="row">
            <div className="col-sm-12">
                <h1>Unit Converters</h1>
                <select className={styles.filter} ref={this.filterRef} onChange={() => this.updateFilter()}>
                    <option value="all">All</option>
                    {
                        this.sortedMeasureToDataKeys.map(measure => {
                            return <option key={this.measureToData[measure].measureReadableName} value={measure}>
                                {this.measureToData[measure].measureReadableName}
                            </option>
                        })
                    }
                </select>

                <input className={styles.filter} ref={this.keywordFilterRef} onInput={(e) => this.keywordFilterChanged()} placeholder="enter term to search..." />
            </div>
            {
                this.sortedMeasureToDataKeys.filter((a) => !this.measureFilter ? true : a === this.measureFilter)
                    .filter(measure => {
                        return this.measureToData[measure].measureUnits.filter(unitDesc => {
                            return this.state.keywordFilter(unitDesc.urlText)
                        }).length > 0;
                    })
                    .map(measure => {
                        return (
                            <div className="col-sm-6 col-md-4 col-lg-4"
                                key={this.measureToData[measure].measureReadableName}>
                                <h2>{this.measureToData[measure].measureReadableName}</h2>
                                <ul>
                                    {
                                        this.measureToData[measure].measureUnits.filter(unitDesc => {
                                            return this.state.keywordFilter(unitDesc.urlText)
                                        }).map((unitDesc, i) => {
                                            return <li key={`${unitDesc.url}${i}`}>
                                                <a href={`${unitDesc.url}`} style={{ textDecoration: 'none' }}>
                                                    {unitDesc.urlText}
                                                    </a>
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                        )
                    })
            }
        </div>
    }
}